import React from 'react'
import styles from './ModalTabs/styles.module.css'

export default function PositionHistoryModal({ history, onClose }) {
  const formatDate = (val) => {
    if (!val) return '—'
    try {
      return new Date(val).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    } catch {
      return val
    }
  }

  return (
    <div className={styles.historyOverlay} onClick={onClose}>
      <div className={styles.historyBox} onClick={e => e.stopPropagation()}>
        <div className={styles.historyHead}>
          История назначений
          <span className={styles.historyClose} onClick={onClose}>✕</span>
        </div>
        <table className={styles.historyTable}>
          <thead>
            <tr>
              <th>Должность занимает</th>
              <th>с</th>
              <th>по</th>
            </tr>
          </thead>
          <tbody>
            {history?.length
              ? history.map((row, i) => (
                  <tr key={i}>
                    <td>{row.fio || row.calc_fio || '—'}</td>
                    <td>{formatDate(row.date_from)}</td>
                    <td>{formatDate(row.date_to)}</td>
                  </tr>
                ))
              : (
                  <tr><td colSpan={3} style={{ textAlign: 'center', color: '#9aa7b8', padding: '16px' }}>Нет данных</td></tr>
                )
            }
          </tbody>
        </table>
        <div className={styles.historyFoot}>
          <button className={styles.historyCloseBtn} onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}
